import { apiSlice } from "services/apiSlice";

export const offerApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getOffers: builder.query({
      query: (companyId) => ({
        url: `offer?companyId=${companyId}`,
        method: "GET",
      }),
      providesTags: ["Offers"],
    }),
    getCategories: builder.query({
      query: () => ({
        url: "category",
        method: "GET",
      }),
      providesTags: ["Offers"],
    }),
    createOffer: builder.mutation({
      query: (offerData) => ({
        url: "offer",
        method: "POST",
        body: offerData,
      }),
      invalidatesTags: ["Offers"],
    }),
    updateOffer: builder.mutation({
      query: ({ id, data }) => ({
        url: `offer/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Offers"],
    }),
    deleteOffer: builder.mutation({
      query: (id) => ({
        url: `offer/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Offers"],
    }),
    getOfferById: builder.query({
      query: ({ id, companyId }) => ({
        url: `offer/${id}/companyId/${companyId}`,
        method: "GET",
      }),
      providesTags: ["Offers"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetOffersQuery,
  useCreateOfferMutation,
  useGetCategoriesQuery,
  useUpdateOfferMutation,
  useDeleteOfferMutation,
  useGetOfferByIdQuery,
  useLazyGetOfferByIdQuery,
} = offerApi;
